import { Theme } from '@mui/material/styles';
import { defaultTheme } from 'react-admin';

declare module '@mui/styles/defaultTheme' {
    interface DefaultTheme extends Theme {}
}

const defaultDarkTheme = { ...defaultTheme, palette: { mode: 'dark' } };

export const lightTheme = {
    ...defaultTheme,
    palette: {
        ...defaultTheme.palette,
        primary: {
            main: '#5581B0',
            contrastText: '#ffffff',
        },
        secondary: {
            light: '#574451',
            main: '#3F2F3A',
            dark: '#2f222b',
            contrastText: '#fff',
        },
    },
    typography: {
        fontFamily: 'Inter',
        h1: {
            fontFamily: 'TT Firs Neue',
        },
        h2: {
            fontFamily: 'TT Firs Neue',
        },
        h3: {
            fontFamily: 'TT Firs Neue',
        },
        h4: {
            fontFamily: 'TT Firs Neue',
        },
        h5: {
            fontFamily: 'TT Firs Neue',
        },
        h6: {
            fontFamily: 'TT Firs Neue',
        },
        subtitle1: {
            fontWeight: '500',
        },
        subtitle2: {
            fontWeight: '500',
        },
        body1: {
            // Make it same as body2
            fontSize: '0.875rem',
            lineHeight: '1.43',
            letterSpacing: '0.01071em',
        },
    },
    sidebar: {
        width: 220,
    },
    components: {
        ...defaultTheme.components,
        RaDatagrid: {
            styleOverrides: {
                root: {
                    width: '100%',
                },
            },
        },
    },
};

export const darkTheme = {
    ...lightTheme,
    ...defaultDarkTheme,
    sidebar: {
        ...lightTheme.sidebar,
    },
    palette: {
        ...defaultDarkTheme.palette,
        primary: {
            ...lightTheme.palette.primary,
        },
        secondary: {
            light: '#3F2F3A',
            main: '#7f838d',
            dark: '#281d25',
            contrastText: '#fff',
        },
    },
};